var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.buttonClass,attrs:{"href":'mailto:?subject=' +
      _vm.subject +
      '&body=' +
      _vm.text +
      '%0D%0D A teljes tartalom a Folkrádió weboldalán érhető el:%0D ' +
      encodeURIComponent(_vm.url)}},[_c('img',{attrs:{"src":"/img/mail_icon.svg","alt":""}}),_vm._v(" "),(_vm.buttonText)?_c('span',[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }